export const TRANSLATION_LOAD_BALANCE = {
  header: {
    breadcrumb: {
      rewards: 'csp.rewards',
      loadBalance: 'rewards.load_balance.header.breadcrumb.load_balance'
    },
    heroTitle: 'sidebar_menu.points.balance',
    card: {
      title: 'rewards.load_balance.header.card.title',
      button: 'rewards.load_balance.header.card.button'
    }
  },
  cards: {
    title1: 'rewards.load_balance.cards.title_1',
    statusCard1: 'rewards.load_balance.cards.status_card_1',
    input: 'rewards.load_balance.cards.input',
    title2: 'rewards.load_balance.cards.title_2',
    creditInformation: 'rewards.load_balance.payment_method.credit_information',
    total: 'rewards.load_balance.cards.total',
    radioButton1: 'rewards.load_balance.cards.radio_button_1',
    radioButton2: 'rewards.load_balance.cards.radio_button_2',
    statusCard2: 'rewards.load_balance.cards.status_card_2',
    transferTitle1: 'rewards.load_balance.cards.transfer_title_1',
    transferTitle2: 'rewards.load_balance.cards.transfer_title_2',
    transferFileTitle: 'rewards.load_balance.cards.transfer_file_title',
    creditTitle1: 'rewards.load_balance.cards.credit_title_1',
    tooltipCreditLine: 'rewards.load_balance.cards.tooltip_credit_line',
    creditFileTitle: 'rewards.load_balance.cards.credit_file_title',
    transferData: {
      name: 'rewards.load_balance.cards.transfer_data.name',
      rut: 'rewards.load_balance.cards.transfer_data.rut',
      type: 'rewards.load_balance.cards.transfer_data.type',
      account: 'rewards.load_balance.cards.transfer_data.account',
      email: 'rewards.load_balance.cards.transfer_data.email'
    },
    purchaseOrder: {
      number: 'rewards.load_balance.cards.purchase_order.number',
      codeHes: 'rewards.load_balance.cards.purchase_order.code_hes',
      dateHes: 'rewards.load_balance.cards.purchase_order.date_hes'
    }
  },
  button: 'rewards.load_balance.button',
  success: {
    title: 'rewards.load_balance.success.title',
    transferDescription: 'rewards.load_balance.success.transfer_description',
    creditDescription: 'rewards.load_balance.success.credit_description',
    primaryButton: 'rewards.load_balance.success.primary_button',
    secondaryButton: 'rewards.load_balance.success.secondary_button'
  },
  error: {
    title: 'rewards.load_balance.error.title',
    description: 'rewards.load_balance.error.description',
    primaryButton: 'rewards.load_balance.error.primary_button',
    secondaryButton: 'rewards.load_balance.error.secondary_button'
  }
};

export const TRANSLATION_POINTS = {
  header: {
    breadcrumb: {
      rewards: 'csp.rewards',
      sendPoints: 'rewards.points.header.breadcrumb.send_points'
    },
    heroTitle: 'rewards.points.header.breadcrumb.send_points',
    heroDescription: 'rewards.points.header.title'
  },
  tabs: {
    send: 'rewards.points.segment.select_collaborators',
    schedule: 'rewards.points.tabs.schedule',
    file: 'rewards.points.segment.file'
  },
  send_points: {
    title: 'rewards.points.send_points.title',
    description: 'rewards.points.send_points.description',
    searchPlaceholder: 'rewards.points.send_points.search_placeholder',
    info: 'rewards.points.config.info',
    table: {
      header: {
        email: 'csp.email',
        name: 'csp.name',
        status: 'csp.status',
        id: 'csp.id'
      },
      toolbar: {
        employeesSelected: 'rewards.points.send_points.table.toolbar.employees_selected',
        employeesSelectedPlural: 'rewards.points.send_points.table.toolbar.employees_selected_plural',
        actionButton: 'rewards.points.send_points.table.toolbar.action_button'
      },
      select_all_menu: {
        all: 'rewards.points.send_points.table.select_all_menu.all',
        page: 'rewards.points.send_points.table.select_all_menu.page'
      }
    }
  }
};

export const TRANSLATION_POINTS_BY_FILE = {
  header: {
    breadcrumb: {
      rewards: 'csp.rewards',
      sendPoints: 'rewards.points.header.breadcrumb.send_points'
    },
    heroTitle: 'rewards.points.header.breadcrumb.send_points'
  },
  emailsConfiguration: {
    title: 'rewards.points.config.custom_email.title',
    selectorTitle: 'rewards.points.config.custom_email.select_template_label',
    selectorPlaceholder: 'rewards.points.config.custom_email.select_template_placeholder',
    messageLabel: 'rewards.points.config.custom_email.write_message_label',
    textAreaPlaceholder: 'rewards.points.config.custom_email.write_message_placeholder',
    previewTitle: 'global.preview.main',
    category: {
      birthday: 'global.birthday.main',
      christmas: 'global.christmas.main',
      generic: 'global.generic.main',
      celebration: 'global.celebration.main'
    }
  },
  uploadFile: {
    title: 'rewards.points.file_upload.title',
    description: 'rewards.points.file_upload.description  ',
    downloadTemplate: 'add_collaborator.ne.form.button_1',
    fileUploader: {
      title: 'add_collaborator.ne.form.title_file_input',
      deleteFile: 'file_uploader.delete_file',
      error: {
        maxRows: 'add_collaborator.ne.form.error_maximum_rows',
        emptyFile: 'error_message.excel.empty_file',
        format: 'error_message.excel.general_format',
        default: 'add_collaborator.ne.form.default_error',
        noValidData: 'add_collaborator.ne.form.multiple_errors'
      }
    },
    info: {
      title: 'rewards.points.file_upload.info.title',
      description: 'rewards.points.file_upload.info.description'
    }
  },
  details: {
    title: 'rewards.points.detail.title',
    header: {
      collaborators: 'rewards.points.config.points.table.header.collaborators',
      points: 'rewards.points.config.points.table.header.points',
      total: 'csp.total'
    },
    values: {
      collaborators: 'rewards.points.config.points.table.values.collaborators',
      collaboratorsPlural: 'rewards.points.config.points.table.values.collaborators_plural',
      points: 'rewards.points.config.points.table.values.points',
      pointsPlural: 'rewards.points.config.points.table.values.points_plural'
    },
    sendTotal: 'rewards.points.detail_table.total.description',
    insufficientPoints: 'rewards.points.config.points.status_card_no_button'
  },
  fileErrorModal: {
    title: 'rewards.points.file_error_modal.title',
    description: 'rewards.points.file_error_modal.description',
    correctAmount: 'rewards.points.file_error_modal.detail_sent',
    errorAmount: 'rewards.points.file_error_modal.detail_not_sent',
    continue: 'rewards.points.file_error_modal.button',
    close: 'global.button.later'
  },
  success: {
    title: 'rewards.points.config.success.title',
    description: 'rewards.points.config.success.description',
    tag: 'rewards.points.success.order_number',
    history: 'rewards.points.config.success.primary_button',
    sendMorePoints: 'rewards.points.config.success.secondary_button'
  },
  successWithErrors: {
    successCard: {
      title: 'rewards.points.success.pending_points.title'
    },
    reminderCard: {
      title: 'rewards.points.file_error.remider_card.title',
      description: 'rewards.points.file_error.remider_card.description',
      downloadErrors: 'button.download_errors',
      fileUploader: 'global.upload_file.fixed_file.input_title'
    },
    buttons: {
      skip: 'button.skip_and_end',
      missingPoints: 'rewards.points.config.button.send_pending'
    }
  },
  error: {
    title: 'rewards.points.config.error.title',
    description: 'rewards.points.config.error.description',
    retry: 'csp.retry',
    cancel: 'button.cancel'
  },
  sendPoints: 'rewards.points.config.button.send_points'
};

export const TRANSLATION_POINTS_CONFIG = {
  collaborators: {
    title: 'rewards.points.config.collaborators.title',
    text: 'rewards.points.config.collaborators.text',
    textPlural: 'rewards.points.config.collaborators.text_plural',
    button: 'rewards.points.config.collaborators.button',
    statusCard: 'rewards.points.config.collaborators.status_card'
  },
  points: {
    title: 'rewards.points.config.points.title',
    inputLabel: 'rewards.points.config.points.input_label',
    table: {
      header: {
        collaborators: 'rewards.points.config.points.table.header.collaborators',
        points: 'rewards.points.config.points.table.header.points',
        total: 'rewards.points.config.points.table.header.total'
      },
      values: {
        collaborators: 'rewards.points.config.points.table.values.collaborators',
        collaboratorsPlural: 'rewards.points.config.points.table.values.collaborators_plural',
        points: 'rewards.points.config.points.table.values.points',
        pointsPlural: 'rewards.points.config.points.table.values.points_plural'
      }
    },
    statusCard: 'rewards.points.config.points.status_card_general',
    statusCardButton: 'rewards.points.config.points.status_card_button'
  },
  button: 'rewards.points.config.button.send_points',
  success: {
    title: 'rewards.points.config.success.title',
    description: 'rewards.points.config.success.description',
    primaryButton: 'rewards.points.config.success.primary_button',
    secondaryButton: 'rewards.points.config.success.secondary_button'
  },
  error: {
    title: 'rewards.points.config.error.title',
    description: 'rewards.points.config.error.description',
    primaryButton: 'rewards.points.config.error.primary_button',
    secondaryButton: 'rewards.points.config.error.secondary_button'
  }
};

export const TRANSLATION_HISTORY = {
  header: {
    breadcrumb: {
      rewards: 'csp.rewards',
      history: 'csp.history'
    },
    heroTitle: 'csp.history'
  },
  filterButton: 'global.button.filter',
  tabs: {
    points: 'rewards.history.tabs.points',
    balance: 'rewards.history.tabs.balance'
  },
  table: {
    refresh: 'rewards.history.table.refresh',
    allStatus: 'rewards.history.table.all_status',
    searchPlaceholder: 'rewards.history.table.search_placeholder',
    table: {
      header: {
        details: 'rewards.history.table.header.details',
        order: 'rewards.history.table.header.order',
        responsable: 'rewards.history.table.header.responsable',
        sendDate: 'rewards.history.table.header.send_date',
        loadDate: 'rewards.history.table.header.load_date',
        status: 'rewards.history.table.header.status',
        amount: 'rewards.history.table.header.amount'
      }
    },
    details: {
      deposits: 'rewards.history.table.details.deposits',
      outgoings: {
        points: 'rewards.history.table.details.outgoings.points',
        birthday: 'rewards.history.table.details.outgoings.birthday'
      }
    },
    status: {
      all: 'rewards.history.table.status.all',
      sent: 'rewards.history.table.status.sent',
      sentTooltip: 'rewards.history.table.status.sent_tooltip',
      failed: 'rewards.history.table.status.failed',
      failedTooltip: 'rewards.history.table.status.failed_tooltip',
      approved: 'rewards.history.table.status.approved',
      rejected: 'rewards.history.table.status.rejected',
      inProgress: 'rewards.history.table.status.in_progress'
    }
  },
  error: {
    title: 'rewards.history.error.title',
    subtitle: 'rewards.history.error.subtitle'
  }
};

export const TRANSLATION_ORDER_HISTORY_DETAIL = {
  header: {
    breadcrumb: {
      rewards: 'csp.rewards',
      history: 'csp.history',
      detail: 'csp.details'
    },
    heroTitle: 'csp.history'
  },
  filterButton: 'global.button.filter',
  title: {
    points: 'rewards.history_details.title.points',
    milestones: 'rewards.history_details.title.milestones',
    deposits: 'rewards.history_details.title.deposits'
  },
  orderInfo: {
    title: 'rewards.history_details.order_info.order_detail',
    table: {
      status: 'csp.status',
      charges: 'rewards.history_details.order_info.charges.title',
      sendDate: 'csp.date_sent',
      paymentType: 'csp.payment',
      total: 'csp.total',
      values: {
        charges: 'rewards.history_details.order_info.charges.value'
      }
    },
    status: {
      deposits: {
        done: 'csp.approved',
        'invoice-pending': 'csp.in_progress',
        'pending-payment': 'csp.in_progress',
        'pending-delivery': 'csp.in_progress',
        voided: 'csp.requests_status.rejected'
      },
      outgoings: {
        done: 'csp.sent',
        'invoice-pending': 'csp.in_progress',
        'pending-payment': 'csp.in_progress',
        'pending-delivery': 'csp.in_progress',
        voided: 'csp.failed'
      }
    },
    paymentMethod: {
      balance: 'rewards.history_details.order_info.payment_method.balance',
      credit: 'rewards.history_details.order_info.payment_method.credit-line',
      transfer: 'rewards.history_details.order_info.payment_method.transfer'
    },
    steps: {
      received: 'rewards.history_details.order_info.steps.received',
      invoiced: 'rewards.history_details.order_info.steps.invoiced',
      validated: 'rewards.history_details.order_info.steps.validated',
      approved: 'rewards.history_details.order_info.steps.approved'
    },
    tooltip: {
      done: 'rewards.history.table.status.sent_tooltip',
      voided: 'rewards.history.table.status.failed_tooltip',
      inProgress: 'rewards.history_details.order_info.in_progress.tooltip'
    }
  },
  orderDetailsTable: {
    title: 'rewards.history_details.order_details.title',
    pendingErrors: 'rewards.history.banner.pending_errors',
    searchPlaceholder: 'rewards.history_details.order_details.search_placeholder',
    searchMobile: 'csp.search',
    table: {
      email: 'csp.email',
      name: 'csp.name',
      points: 'csp.points',
      status: 'csp.load_status'
    },
    status: {
      all: 'rewards.history.table.all_status',
      assigned: 'rewards.history_details.order_details.table.status.received',
      pending: 'rewards.history_details.order_details.table.status.sent',
      voided: 'rewards.history_details.order_details.table.status.voided'
    }
  },
  error: {
    noDataFilter: {
      title: 'rewards.history.error.title',
      description: 'rewards.history.error.subtitle'
    },
    noData: {
      title: 'rewards.history_details.order_details.table.error.title',
      description: 'csp.empy_state.retry',
      buttonText: 'button.retry'
    }
  }
};
